import React, {useRef, useState} from "react";

const EmailTraces = () => {
  const [loading, setLoading] = useState(true)
    const iFrameRef = useRef(null);
     const AuthorizationToken = localStorage.getItem('MSAL_TOKEN');
    let url = process.env.REACT_APP_IFRAME_URL.toString() + "?token=" + AuthorizationToken + "&country=JPN&region=APAC&tfId=en";
    const hideSpinner = () => {
        setLoading(false);
    };

    return (
     <div className="traces-exceptions-page">
      <div className="traces-exceptions-header">
        <div className="traces-exceptions-title">
          <span>Logs/Traces</span>
        </div>
        <div
          className="container-fluid"
          style={{
            background: "#1F1F1F 0% 0% no-repeat padding-box",
            border: "1px solid #707070",
            width: "100%",
            padding: "10px",
          }}
        >
<iframe
  ref={iFrameRef}
  onLoad={hideSpinner}
  style={{width:"100%", height:"82vh"}}
  className="iframe"
  src={url}
  sandbox="allow-scripts allow-same-origin allow-top-navigation"
  title="message-center-iframe"
/>
        </div>
      </div>
    </div>
  );
};

export default EmailTraces;